export const PRESCRIPTION_ONLY_TEMPLATE_TAG = 'DOCUMENTATION_SCOPE:PRESCRIPTION_ONLY';
